export default {"src":"/_next/static/media/verified.a3e0f306.svg","height":15,"width":16,"blurWidth":0,"blurHeight":0};